module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chap",
    attrs: {
      "id": "chap-006"
    }
  }, [_c('div', {
    staticClass: "chap_debut"
  }), _c('h1', {
    staticClass: "chap_tit"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("DIVINE ACCUSATIONS AGAINST ISRAEL"), _c('br')]), _c('a', {
    staticClass: "url",
    attrs: {
      "href": "https://www.biblegateway.com/passage/?search=Hosea+4%3A1-8&version=RSV",
      "target": "_blank"
    }
  }, [_vm._v("HOSEA 4:1-8")])])]), _c('div', {
    staticClass: "dev"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("VERVIEW")]), _vm._v(":")]), _vm._v(" The continued hardness of heart in the covenant people was repeatedly played out among the ancient Jews. Repentance is as much a requirement in the new covenant as was expected in the old (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERUSALEM")]), _vm._v("). Israel is compared to a priest who has been dishonored. The stumbling of the people is like one in the darkness (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA")]), _vm._v("). Yet their judgment is temporary (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v("). The mother of the night was Mary, through whom Christ was born. Furthermore, Jesus was born at night and rose from the dead at night (or dawn) too. The woman and the night are compared with sin, in contrast to those who live in the light (A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v("). The mother of the people is the synagogue (T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOPHYLACT")]), _vm._v("). The priests used to eat the sacrifices, thereby eating sins of the people (C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(") and approving of them (J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v("). Christ is the ultimate sacrifice who continually devours sin by his saving grace and which is now mediated through his priesthood. The cleansing sacrifice for sin is now perpetually offered up by priests in the Eucharist sacrifice (O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(").")]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-045"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("4:2"), _c('i', [_vm._v(" They Break All Bounds")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("O")]), _vm._v(" R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EPENTANCE.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERUSALEM")]), _vm._v(": After Moses, prophets were sent to heal Israel. But in their exercise of healing they deplored the fact that they could not overcome evil, so that one of them says, “The faithful are gone from the earth, among men the upright are no more,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN87",
      "id": "ap_NFIN87-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" and again, “All alike have gone astray; they have become perverse; there is not one who does good, not even one.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN88",
      "id": "ap_NFIN88-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" And again, “Cursing, and theft, and adultery, and killing have overflowed” upon the land. “They sacrificed their sons and daughters to demons.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN89",
      "id": "ap_NFIN89-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" They engaged themselves in auguries and enchantments and divinations; and again, “they fastened their garments with cords and hung veils next to the altar.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN90",
      "id": "ap_NFIN90-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATECHETICAL")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ECTURE 12.6.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN91",
      "id": "ap_NFIN91-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-046"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("4:4"), _c('i', [_vm._v(" Dispute with a Priest")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SRAEL")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IKE A")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMPROMISED")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIEST.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA")]), _vm._v(": My people are like a priest who is compromised. He has fallen from his previous dignity and does not appear worthy for any reason, just as a priest who falls into controversy would be set aside and dishonored by everyone. “And he will be weak by day.” To the greatest extent he will become weak because of the upcoming evils. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN92",
      "id": "ap_NFIN92-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-047"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("4:5"), _c('i', [_vm._v(" Stumbling During the Day")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TUMBLING AS IN")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARKNESS.")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEODORE OF")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OPSUESTIA")]), _vm._v(": Of the ones who first made use of false predictions to deceive you, most will also themselves become weak because of the calamity that holds them back. As if they were wrapped up in some kind of night darkness, they see the pursuit of deceit, which was useless for them. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN93",
      "id": "ap_NFIN93-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UDGMENT")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EMPORARY.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(": One says that Israel will be weak not forever but for days. For it has been reserved for her a time of salvation and a return to faith. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 3.37.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN94",
      "id": "ap_NFIN94-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('b', [_vm._v("A S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("TAR OF THE")]), _vm._v(" N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IGHT.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(": For us too, you see, once the night of this age is done, there will be a resurrection of the flesh for the kingdom; it’s the model or sample of this that has already occurred in our head. That, indeed, is why the Lord wished to rise again at night; because, in the apostle’s words, “God, who commanded the light to shine out of the darkness, has shone in our hearts.”")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN95",
      "id": "ap_NFIN95-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" So the Lord represented light shining out of darkness by being born at night and also by rising at night. Light out of darkness, in fact, is Christ out of the Jews, to whom it was said, “I have likened your mother to night.” But in that nation, as it were in that night, the virgin Mary was not night but somehow or other a star of the night; which is why a star also signaled her childbearing, guiding a far distant night, that is the magi from the east, to worship the light. Thus in them too would be realized the command to “the light to shine out of darkness.” S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ERMON 223D.2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN96",
      "id": "ap_NFIN96-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EFERRING TO")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN.")])]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UGUSTINE")]), _vm._v(": “Day continues according to your ordinance.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN97",
      "id": "ap_NFIN97-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" For all these things are day: “and this is the day which the Lord has made; let us rejoice and be glad in it”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN98",
      "id": "ap_NFIN98-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" and “let us walk honestly as in the day.”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN99",
      "id": "ap_NFIN99-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" “For all things serve you.” He said “all things of some,” “all” which belong to this day “serve you.” For the ungodly, of whom it is said, “I have compared thy mother unto the night,” do not serve you. E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("XPLANATION OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("SALMS 119.91.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN100",
      "id": "ap_NFIN100-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YNAGOGUE")]), _vm._v(" I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S THE “")]), _vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OTHER.”")])]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEOPHYLACT")]), _vm._v(": The mother of the people is the synagogue, which—since it is covered by the darkness of ignorance and did not receive the radiance of God’s knowledge—may be compared to the night. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN101",
      "id": "ap_NFIN101-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])])]), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-048"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("4:8 "), _c('i', [_vm._v("Feeding on Sin")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HEY")]), _vm._v(" E"), _c('span', {
    staticClass: "small"
  }, [_vm._v("AT THE")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFERINGS.")])]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("YRIL OF")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("LEXANDRIA")]), _vm._v(": They used to sacrifice goats for sin; for this reason the sacrifice was called sin. By offering a goat on the altar, the priests at the right time used to bring the intestines and the lard, and they ate the rest. This was ordered by the divine law."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN102",
      "id": "ap_NFIN102-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" . . . “They eat the sins of my people” means they eat the offerings brought for sins. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 3.40.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN103",
      "id": "ap_NFIN103-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIESTS")]), _vm._v(" A"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PPROVE OF")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("INS.")])]), _vm._v(" J"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EROME")]), _vm._v(": [The priests] are feasting on the sins of my people, approving the crimes of the sinners. For when they behold them sinning, not only do they not argue but they praise and extol them, calling them fortunate. C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMMENTARY ON")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OSEA 1.4.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN104",
      "id": "ap_NFIN104-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _c('p', {
    staticClass: "bl"
  }), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('b', [_vm._v("C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HRIST THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIEST")]), _vm._v(" D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVOURS")]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("UR")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("IN.")])]), _vm._v(" O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RIGEN")]), _vm._v(": The text wants you to make a more daring assertion if your hearing will still follow. What is the “sacrifice” that is offered “for sin” and is “very holy” except “the only begotten Son of God,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN105",
      "id": "ap_NFIN105-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" Jesus Christ my Lord? He alone is the “sacrifice for sins,” and he is “a very holy offering.” But since it added that “the priest who offers it will eat it,”"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN106",
      "id": "ap_NFIN106-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" it seems to be hard to understand. For that which it says must be eaten seems to be referring to the sin, just as in another place the prophet says concerning the priests that “they will eat the sins of my people.” This also shows that the priest ought to eat the sin of the one who is offering. We frequently show from holy Scripture that Christ is also the sacrifice that is offered for the sin of the world and the priest who brings the offering. H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMILIES ON")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EVITICUS 5.2.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen15#NFIN107",
      "id": "ap_NFIN107-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-091d3380","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/p1chap7.vue
// module id = 99
// module chunks = 0